import '@splidejs/splide/dist/css/splide-core.min.css';
import "../../scss/pages/press.scss";
import Splide from '@splidejs/splide';

export default class Press {
	/**
	 * get splide slider options
	 * @param slidePerPage - number - slider to display per page
	 * @param slideGap - number - padding of slider
	 * @param direction - string - rtl or ltr direction
	 * @param arrows - boolean - enable arrow on slider
	 * @param pagination - boolean - enable thumbnails on slider
	 * @return options - Object - options for slider
	 */
	getSliderOptions(slidePerPage = 1, slideGap = 25, direction = 'ltr', arrows = false, pagination = false) {
		return {
			type: 'loop',
			autoplay: 'start',
			autoScroll: {
				speed: 2,
			},
			perPage: slidePerPage,
			focus: 'center',
			direction: direction,
			arrows: arrows,
			pagination: pagination,
			perMove: 3,
			gap: slideGap,
			start: 0,
			breakpoints: {
				991.98: {
					perPage: 2,
					gap: 7,
					perMove: 1,
				},
				1199.98: {
					gap: 40,
				},
			}
		}
	}
}

document.addEventListener("DOMContentLoaded", function () {
	const bodyElement = document.querySelector('body');
	const pressModule = new Press();
	const quotationsSlider = new Splide('#quotationSlider', pressModule.getSliderOptions(5, 25, bodyElement.dir));
	const reviewSlider = new Splide('#reviewSlider', pressModule.getSliderOptions(3, 30, bodyElement.dir));
	
	quotationsSlider.on('mounted', function () {
		if (quotationsSlider.length <= quotationsSlider.options.perPage) {
			quotationsSlider.options.perPage = quotationsSlider.length;
		}
	});
	
	reviewSlider.on('mounted', function () {
		if (reviewSlider.length <= reviewSlider.options.perPage) {
			reviewSlider.options.perPage = reviewSlider.length;
		}
	});
	
	quotationsSlider.mount();
	reviewSlider.mount();
});